import type { FC } from 'react';
import { Card, LabeledList, LabeledListItem, SkeletonLine } from '@george-labs.com/design-system';

import { getRandomNumber } from '../ProductSkeletonService';

const MIN_WIDTH = 50;
const MAX_LABEL_WIDTH = 80;
const MAX_CONTENT_WIDTH = 70;

interface ListItemSkeletonProps {
    'data-cy'?: string;
}

export const ListItemSkeleton: FC<ListItemSkeletonProps> = ({ 'data-cy': dataCy }) => (
    <LabeledListItem
        label={
            <SkeletonLine
                animated
                level={3}
                percentageWidth={getRandomNumber(MIN_WIDTH, MAX_LABEL_WIDTH)}
            />
        }
        data-cy={dataCy}
    >
        <SkeletonLine
            animated
            level={3}
            percentageWidth={getRandomNumber(MIN_WIDTH, MAX_CONTENT_WIDTH)}
        />
    </LabeledListItem>
);

const DEFAULT_NUMBER_OF_ROWS = 6;

interface Props {
    className?: string;
    numberOfRows?: number;
    'data-cy'?: string;
}

export const ListSkeleton: FC<Props> = ({
    className,
    numberOfRows = DEFAULT_NUMBER_OF_ROWS,
    'data-cy': dataCy,
}) => (
    <Card data-cy={dataCy} className={className}>
        <LabeledList labelColumnWidth={6} variant={LabeledList.VARIANT.PLAIN}>
            {[...Array(numberOfRows).keys()].map((i) => (
                <ListItemSkeleton key={`list-skeleton-item-${i}`} />
            ))}
        </LabeledList>
    </Card>
);
